import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeOpenText from './icon-envelope-open-text.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeOpenText {...validProps} />;
}
SvgComponent.iconName = 'envelopeOpenText';

/**
 * @deprecated This is a legacy icon
 */
export const EnvelopeOpenTextIcon = svgIconWrapper(SvgComponent);
